module.exports = "/_next/static/images/Hero@2x-811be9ab17e8d8551b3af3d4836ddc0b.png";